import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GoHome, GoHomeFill } from "react-icons/go";
import { TbCategory, TbCategoryFilled } from "react-icons/tb";
import { FaPlus } from "react-icons/fa";
import { BsArrowUpCircleFill } from "react-icons/bs";
import { AiOutlineMessage, AiFillMessage } from "react-icons/ai";
import { LuCircleFadingArrowUp } from "react-icons/lu";

export default function BottomNavigation({ isVisible }) { // Add isVisible prop
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { 
      name: 'Home', 
      icon: GoHome, 
      activeIcon: GoHomeFill, 
      path: '/' 
    },
    { 
      name: 'Categories', 
      icon: TbCategory, 
      activeIcon: TbCategoryFilled, 
      path: '/categories' 
    },
    { 
      name: 'Add', 
      icon: FaPlus,
      activeIcon: FaPlus, 
      path: '/upload-listing' 
    },
    { 
      name: 'Updates', 
      icon: LuCircleFadingArrowUp, 
      activeIcon: BsArrowUpCircleFill, 
      path: '/status' 
    },
    { 
      name: 'Inbox', 
      icon: AiOutlineMessage, 
      activeIcon: AiFillMessage, 
      path: '/messages' 
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className={`fixed bottom-0 left-0 right-0 bg-black border-t border-gray-800 md:hidden z-50 transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`}>
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const isAddIcon = item.name === 'Add';
          const IconComponent = isActive ? item.activeIcon : item.icon;

          return (
            <button
              key={item.name}
              onClick={() => handleNavigation(item.path)}
              className={`flex flex-col items-center justify-center flex-1 text-gray-400 focus:outline-none ${
                isAddIcon ? 'relative -mt-2' : ''
              }`}
            >
              {isAddIcon ? (
                <div className="add-button-container flex items-center justify-center w-14 h-8 rounded-lg bg-gradient-to-r from-[#FF1493] to-[#00BFFF]">
                  <IconComponent
                    size={24}
                    className="text-white"
                  />
                </div>
              ) : (
                <>
                  <IconComponent
                    size={24}
                    className={isActive ? 'text-white' : 'text-gray-400'}
                  />
                  <span
                    className={`text-xs mt-1 ${
                      isActive ? 'text-white' : 'text-gray-400'
                    }`}
                  >
                    {item.name}
                  </span>
                </>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}